<template>
    <div class="list-member">
        <!-- <label for="">Danh sách học sinh trong nhóm</label> -->
        <b-table striped hover :fields="fieldsTableMember" :items="listMember">
            <template #head(stt)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>

            <template #head(name)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>

            <template #cell(action)="row">
                <span @click="handleChangeNameMember(row)" class="mr-1 btn-edit">
                    Sửa
                </span>
                /
                <span @click="handleDeleteMember(row)" class="mr-1 btn-delete">
                    Xóa
                </span>
            </template>

            <template #cell(name)="data">
                <router-link :to="{ path: 'thong-ke-hoc-sinh', query: { userId: data.item.userId, classSchoolId: data.item.classSchoolId } }" target="_blank"
                    class="text-default p-0 m-0">
                    <span class="text-primary">{{ data.item.name }}</span>
                </router-link>
            </template>
        </b-table>
        <ModalChangeNameMemberClassSchool v-if="isShowModalChangeNameClassSchool" :item="dataUserSelected"
            @closeModal="closeModalChangeNameMember" @handleDone="handleDoneChangeName" />
        <ModalDeleteUserGroupClassSchool v-if="isShowModalDeleteUserGroupClassSchool"
            @closeModal="closeModalDeleteMember" :item="dataUserSelected" @handleDeleteDone="handleDeleteDone" />
    </div>
</template>
<script>
import { getListMemberByGroupId } from './../../_api/classSchoolGroupUserServices'
import ModalChangeNameMemberClassSchool from './../../_components/ModalChangeNameMemberClassSchool.vue'
import ModalDeleteUserGroupClassSchool from './../../_components/ModalDeleteUserGroupClassSchool.vue'
export default {
    props: {
        classSchoolGroupId: {
            type: Number,
            default: 0
        }
    },
    components: {
        ModalChangeNameMemberClassSchool,
        ModalDeleteUserGroupClassSchool
    },
    watch: {
        'classSchoolGroupId': 'getListMemberByGroupId'
    },
    data() {
        return {
            fieldsTableMember: [
                { key: 'stt', label: 'STT', thClass: 'w-60px text-center', tdClass: 'w-60px text-center' },
                { key: 'name', label: 'Họ tên học sinh' },
                { key: 'action', label: '' }
            ],
            listMember: [],
            itemSelected: {},
            isShowModalChangeNameClassSchool: false,
            dataUserSelected: {},
            isShowModalDeleteUserGroupClassSchool: false
        }
    },
    mounted() {
        this.getListMemberByGroupId()
        console.log(this.listMember)
    },
    methods: {
        handleChangeNameMember(row) {
            this.itemSelected = row.item
            this.dataUserSelected = {
                name: this.itemSelected.name,
                id: this.itemSelected.classSchoolUserId
            }
            this.isShowModalChangeNameClassSchool = true
        },
        closeModalChangeNameMember() {
            this.isShowModalChangeNameClassSchool = false
        },
        handleDoneChangeName() {
            this.getListMemberByGroupId()
            this.closeModalChangeNameMember()
        },
        handleDeleteMember(row) {
            this.itemSelected = row.item
            this.dataUserSelected = {
                name: this.itemSelected.name,
                userId: this.itemSelected.userId,
                groupId: this.itemSelected.groupId
            }
            this.isShowModalDeleteUserGroupClassSchool = true
        },
        closeModalDeleteMember() {
            this.isShowModalDeleteUserGroupClassSchool = false
        },
        handleDeleteDone() {
            this.getListMemberByGroupId()
            this.closeModalDeleteMember()
        },
        getListMemberByGroupId() {
            this.listMember = []
            let groupId = this.classSchoolGroupId
            getListMemberByGroupId(groupId).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listMember.push({ 'id': item.id, 'classSchoolUserId': item.classSchoolUserId, 'stt': i + 1, 'name': item.userName, userId: item.userId, groupId: item.groupId },)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-edit {
    color: #8ba3f9;
    cursor: pointer;
}

.btn-delete {
    color: red;
    cursor: pointer;
}
</style>